import { createSlice } from '@reduxjs/toolkit';
import {
  fetchCarHouseUsers,
  addCarHouseUser,
  editCarHouseUser,
  removeCarHouseUser,
} from '../actions/carHouseUser-actions';

const initialState = {
  isLoading: false,
  carHouseUsers: [],
  count: 0,
};

const carHouseUserSlice = createSlice({
  name: 'carHouseUser',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchCarHouseUsers.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(fetchCarHouseUsers.fulfilled, (state, action) => {
        const { users, count } = action.payload;
        state.carHouseUsers = users;
        state.count = count;
        state.isLoading = false;
      })
      .addCase(fetchCarHouseUsers.rejected, (state, action) => {
       // state.isLoading = false;
      })
      .addCase(addCarHouseUser.fulfilled, (state, action) => {
        const newUser = action.payload;

        state.carHouseUsers.unshift(newUser);

        state.carHouseUsers = state.carHouseUsers.sort((a, b) => {
          return a.position - b.position;
        });
      })
      .addCase(removeCarHouseUser.fulfilled, (state, action) => {
        const userId = action.payload;

        state.carHouseUsers = state.carHouseUsers.filter(
          (user) => user.id !== userId
        );
      })
      .addCase(editCarHouseUser.fulfilled, (state, action) => {
        const editUser = action.payload;
        const index = state.carHouseUsers.findIndex(
          (user) => user.id === editUser.id
        );
        if (~index) {
          state.carHouseUsers[index] = editUser;
        }
      });
  },
});

export const carHouseUserActions = carHouseUserSlice.actions;

export default carHouseUserSlice;
